import { format, isValid, parse } from 'date-fns';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import { ICON_ALIASES } from '_constants/icons';
import { theme } from '_constants/theme';

import Icon from 'components/atomic/Icon';
import Text from 'components/atomic/layouts/Text';

const StyledContainer = styled.div`
  display: grid;
  grid-template-columns: 28px auto 8px;

  margin-bottom: ${theme.spaces.medium}px;
  cursor: pointer;

  > * {
    &:nth-child(1) {
      grid-row-start: 1;
      grid-row-end: 3;
    }

    &:nth-child(2) {
      grid-row-start: 1;
      grid-row-end: 2;
    }

    &:nth-child(3) {
      grid-row-start: 2;
      grid-row-end: 3;
    }

    &:nth-child(4) {
      grid-row-start: 1;
      grid-row-end: 3;
    }
  }
`;

const StyledIconContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

const StyledStatusContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  padding-top: ${theme.spaces.small2X + 2}px;
`;

const StyledDot = styled.div`
  height: 8px;
  width: 8px;
  border-radius: 50%;
  background: ${theme.colors.indigo.primary};
`;

const AnnouncementsListItem = ({ id, title, date, wasRead, onClick, ...restProps }) => {
  const handleClick = () => {
    onClick && onClick(id, wasRead);
  };

  const parsedDate = parse(date, 'MM-dd-yyyy', new Date());

  return (
    <StyledContainer {...restProps} onClick={handleClick}>
      <StyledIconContainer>
        <Icon alias={ICON_ALIASES.sms} color={theme.colors.gray.secondary} />
      </StyledIconContainer>
      <Text size={theme.fontSizes.small} weight={600}>
        {title}
      </Text>
      <Text size={theme.fontSizes.small} weight={400} color={theme.colors.gray.secondary}>
        {isValid(parsedDate) ? format(parsedDate, 'MM/dd/yyyy') : date}
      </Text>
      <StyledStatusContainer>{!wasRead && <StyledDot />}</StyledStatusContainer>
    </StyledContainer>
  );
};

AnnouncementsListItem.propTypes = {
  id: PropTypes.string,
  title: PropTypes.string,
  date: PropTypes.string,
  wasRead: PropTypes.bool,
  onClick: PropTypes.func,
};

export default AnnouncementsListItem;
